//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";

export default {
  name: "advance-list",
  data(vm) {
    return {
      authorize_view: true,
      authorize_add: true,
      authorize_edit: true,
      authorize_del: true,
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      sortField: "checkindate",
      sortOrder: "DESC",
      reqSeq: 0,
      loadedOnce: false,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject"],
      datefrom: null,
      dateto: null,
      dateRange: [],
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      // mDataArray: [
      //   {
      //     no: 1,
      //     date: "1/11/2022",
      //     name: "testname",
      //     customer: "ABS co Ltd",
      //     amount: "10,000",
      //     status: "Unapproved",
      //   },
      //   {
      //     no: 2,
      //     date: "2/11/2022",
      //     name: "testname2",
      //     customer: "ABS co Ltd",
      //     amount: "3,000",
      //     status: "Approved",
      //   },
      // ],
      headers: [
        { text: "ASSIGNMENT / CASE", value: "job_name", sortable: false },
        { text: "CLIENT", value: "customer_name", sortable: false },
        { text: "DATE", value: "checkindate_show", class: "text-no-wrap", cellClass: "text-no-wrap" },
        { text: "START - END TIME", value: "start_end", sortable: false, align: "center", class: "text-no-wrap", cellClass: "text-no-wrap" },
        { text: "HOURS", value: "durationShow", sortable: false, align: "center", class: "text-no-wrap", cellClass: "text-no-wrap" },
        { text: "CHARGE TYPE", value: "chargetype", sortable: false, class: "text-no-wrap", cellClass: "text-no-wrap" },
        { text: "DETAIL", value: "detail", sortable: false },
        { text: "ACTIONS", value: "actions", sortable: false, align: "center", width: "110px" },
      ],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      jobTitle_list: [],
      searchCharge: null,
      searchChargeJob: null,
      searchEmp: [],
      delete_id: 0,
      dialogDeleteActivity: false,
    };
  },

  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  components: {
    SuccessDialog,
  },
  beforeUpdate() { },
  computed: {
    dateRangeText() {
      if (!this.datefrom && !this.dateto) return "";
      return `${unity.formatDate(this.datefrom) || ""} - ${unity.formatDate(this.dateto) || ""}`;
    },
    showingText() {
      const total = Number(this.totalItems) || 0;
      if (!total) return "Showing 0 of 0 items";
      const start = (this.page - 1) * this.itemsPerPage + 1;
      const end = Math.min(this.page * this.itemsPerPage, total);
      return `Showing ${start}–${end} of ${total} items`;
    },
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    await this.loaddata();

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    this.$hideLoader();
  },
  methods: {
    // ===== UI helpers (ไม่เปลี่ยน logic เดิม) =====
    onDateRangeChange(range) {
      const r = [...(range || [])].sort();
      this.datefrom = r[0] || null;
      this.dateto = r[1] || r[0] || null;
      this.menu = false;
      this.findAllByAPISearch();
    },
    async clearAll() {
      this.search = "";
      this.searchCharge = null;
      this.searchChargeJob = null;
      this.datefrom = null;
      this.dateto = null;
      this.dateRange = [];
      await this.findAllByAPISearch();
    },
    prevPage() {
      if (this.page > 1) this.loadDataByPage(this.page - 1);
    },
    nextPage() {
      if (this.page < this.pageCount) this.loadDataByPage(this.page + 1);
    },
    datePart(v) {
      if (!v) return "-";
      const m = String(v).match(/\d{4}-\d{2}-\d{2}|\d{1,2}\/\d{1,2}\/\d{4}/);
      return m ? m[0] : String(v).split(" ")[0];
    },
    timePart(v) {
      if (!v) return "--:--";
      const m = String(v).match(/\b([01]?\d|2[0-3]):[0-5]\d/);
      return m ? m[0].padStart(5, "0") : "--:--";
    },

    // 1. เพิ่มฟังก์ชัน findAllByAPISearch
    async findAllByAPISearch() {
      await this.onSearchPagination();
    },

    // ===== โหลดข้อมูลแบบแบ่งหน้า (ทุกฟังก์ชันใช้ sort เดียวกัน + กัน response เก่าทับ response ใหม่) =====
    async fetchPage(pageNumber) {
      const seq = ++this.reqSeq;
      this.tableLoading = true;
      try {
        const result = await api.getAllActivityByUserIDPaginationV2(
          pageNumber,
          this.itemsPerPage,
          this.sortField,
          this.sortOrder,
          localStorage.getItem(server.USER_ID),
          this.search,
          this.searchCharge,
          this.searchChargeJob,
          this.datefrom,
          this.dateto
        );
        if (seq !== this.reqSeq) return; // มี request ใหม่กว่าแล้ว ทิ้งผลนี้

        const tmp = (result.data.data || []).map((item) => {
          const totalMinutes = Math.round(Number(item.duration) || 0);
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;
          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          return { ...item, durationShow: durationText };
        });

        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;
        const pg = result.data.pagination || {};
        this.totalItems = Number(pg.totalRecords) || 0;
        this.page = Number(pg.currentPage) || pageNumber;
        this.itemsPerPage = Number(pg.recordsPerPage) || this.itemsPerPage;
        this.pageCount = Number(pg.totalPages) || 0;
      } catch (error) {
        if (seq === this.reqSeq) console.error("Error loading activity:", error);
      } finally {
        if (seq === this.reqSeq) this.tableLoading = false;
      }
    },

    // 3. loaddataPagination
    async loaddataPagination() {
      await this.fetchPage(1);
    },

    // 4. onOptionsUpdate (กดหัวตารางเพื่อ sort)
    async onOptionsUpdate(options) {
      const field = (options.sortBy && options.sortBy[0]) || "checkindate";
      const order = options.sortBy && options.sortBy[0]
        ? (options.sortDesc && options.sortDesc[0] ? "DESC" : "ASC")
        : "DESC";
      const changed = field !== this.sortField || order !== this.sortOrder;
      this.sortField = field;
      this.sortOrder = order;
      // โหลดครั้งแรก หรือเมื่อ sort เปลี่ยน → กลับไปหน้า 1
      if (changed || !this.loadedOnce) {
        this.loadedOnce = true;
        await this.fetchPage(1);
      }
    },

    // 5. loadDataByPage
    async loadDataByPage(pageNumber) {
      await this.fetchPage(pageNumber);
    },

    // 6. onSearchPagination
    async onSearchPagination() {
      this.page = 1;
      await this.fetchPage(1);
    },

    editItem() { },
    changelange: function (newVal, oldVal) { },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    finddatafromdate() {
      this.searchStu_date = 1;
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.searchCharge == null) {
          if (this.searchChargeJob == null) {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              return item;
            }
          } else {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto &&
                item.job_name == this.searchChargeJob
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              if (item.job_name == this.searchChargeJob) {
                return item;
              }
            }
          }
        } else {
          if (this.searchChargeJob == null) {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto &&
                item.chargeType == this.searchCharge
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              if (item.chargeType == this.searchCharge) {
                return item;
              }
            }
          } else {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto &&
                item.chargeType == this.searchCharge &&
                item.job_name == this.searchChargeJob
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              if (
                item.chargeType == this.searchCharge &&
                item.job_name == this.searchChargeJob
              ) {
                return item;
              }
            }
          }
        }
      });
    },

    findChaege() {
      // เริ่มจากข้อมูลทั้งหมด
      let filteredData = [...this.dataAll2];

      // กรองด้วย search text
      if (this.search && this.search.trim() !== "") {
        const searchLower = this.search.toLowerCase();

        filteredData = filteredData.filter((item) => {
          return (
            (item.job_name || "").toLowerCase().includes(searchLower) ||
            (item.customer_name || "").toLowerCase().includes(searchLower) ||
            (item.checkInDate_show || "").toLowerCase().includes(searchLower) ||
            (item.checkOutDate_show || "")
              .toLowerCase()
              .includes(searchLower) ||
            (item.durationShow || "").toLowerCase().includes(searchLower) ||
            (item.chargeType || "").toLowerCase().includes(searchLower) ||
            (item.prospect || "").toLowerCase().includes(searchLower) ||
            (item.detail || "").toLowerCase().includes(searchLower)
          );
        });
      }

      // กรองด้วย Charge Type
      if (this.searchCharge) {
        filteredData = filteredData.filter(
          (item) => item.chargeType === this.searchCharge
        );
      }

      // กรองด้วย Assignment
      if (this.searchChargeJob) {
        filteredData = filteredData.filter(
          (item) => item.job_name === this.searchChargeJob
        );
      }

      // กรองด้วยช่วงวันที่
      if (this.datefrom && this.dateto) {
        filteredData = filteredData.filter(
          (item) =>
            item.checkInDate_S >= this.datefrom &&
            item.checkOutDate_S <= this.dateto
        );
      }

      // กรองด้วย Employee (ถ้ามี)
      if (this.searchEmp && this.searchEmp.length > 0) {
        filteredData = filteredData.filter((item) =>
          this.searchEmp.includes(Number(item.userId))
        );
      }

      // อัปเดตข้อมูลที่แสดงในตาราง
      this.mDataArray2 = filteredData;
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();
      // console.log("res loadAuthorize : ", JSON.stringify(res_get));
      this.authorize = res_get.data;
    },

    async loaddata() {
      const res_joblist = await api.getAllJobtitleByDepartment(
        {
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
            department: localStorage.getItem(server.DEPARTMENT_ID),
          },
        }
      );
      this.jobTitle_list = res_joblist.data;

      // const resData = await api.getAllActivityByUserID(
      //   localStorage.getItem(server.USER_ID)
      // );
      // this.dataAll = resData.data;
      // this.mDataArray = resData.data;
      // this.mDataArray.forEach((item) => {
      //   var decimalHour = Number(item.duration);
      //   const hours = Math.floor(decimalHour); // ได้ 3 ชั่วโมง
      //   const minutes = Math.round((decimalHour - hours) * 60);

      //   let durationText = "";
      //   if (hours > 0 && minutes > 0) {
      //     durationText = `${hours} ชั่วโมง ${minutes} นาที`;
      //   } else if (hours > 0) {
      //     durationText = `${hours} ชั่วโมง`;
      //   } else {
      //     durationText = `${minutes} นาที`;
      //   }
      //   item.durationShow = durationText;
      // });
      this.$hideLoader();
    },

    openeditItem(id) {
      this.$router.push(`/edit-activity/${id}`);
    },

    deleteItem(id) {
      this.delete_id = id;
      this.dialogDeleteActivity = true;
    },

    async deleteItemConfirm() {
      this.$showLoader();

      const delete_activity = await api.deleteActivity(this.delete_id);

      if (delete_activity.status == 200 || delete_activity.status == 201) {
        this.dialogDeleteActivity = false;
        await this.loadAuthorize();
        await this.loaddata();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Successfully  Deleted",
          "The activity has been successfully deleted.",
          "text-h5 green--text text-center"
        );
        return;
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบได้",
          "text-h5 red--text text-center"
        );
      }
    },

    closeDelete() {
      this.delete_id = 0;
      this.dialogDeleteActivity = false;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
